import React, { useState } from "react";
import {
  TextType,
  Card,
  Text,
  useTheme,
} from "@suranceadmin/surance-ui-components";
import styles from "./styles";
import { View, TouchableOpacity, Image } from "react-native";
import ChatbotRobot from "@suranceadmin/icons/web/ChatbotRobot";
import RiskLevel4FullySafe from "@suranceadmin/icons/web/RiskLevel4FullySafe";
import ArrowDown from "@suranceadmin/icons/web/ArrowDown";
import Hyperlink from "react-native-hyperlink";

const ChatBubbleMe = ({ theme, children }) => (
  <View
    style={[
      styles.chatBubbleMeContainer,
      { backgroundColor: theme.colors.background.default },
    ]}
  >
    {children}
  </View>
);

const ChatBubbleBot = ({ theme, children }) => (
  <View style={styles.flexDirectionRow}>
    <ChatbotRobot
      style={styles.chatBotRobot}
      color={theme.colors.icon.default}
    />
    <Card
      isShadowDisplayed={true}
      style={[
        styles.chatBubbleBotContainer,
        { borderColor: theme.colors.line.light },
      ]}
    >
      {children}
    </Card>
  </View>
);

const Accordion = ({ item }) => {
  const theme = useTheme();
  const { title, subtitle, text } = item;
  const [isOpen, setIsOpen] = useState(false);
  return (
    <TouchableOpacity
      onPress={() => {
        setIsOpen(!isOpen);
      }}
    >
      <View style={styles.accordionTitle}>
        <Text type={TextType.Caption1Bold}>{title}</Text>
        <View
          style={{
            ...{
              transform: [{ rotate: isOpen ? "180deg" : "0deg" }],
            },
            ...styles.accordionArrow,
          }}
        >
          <ArrowDown color={theme.colors.icon.default} />
        </View>
      </View>
      <Text style={styles.cardSubtitle} type={TextType.Caption2}>
        {subtitle}
      </Text>
      {isOpen && (
        <Hyperlink
          linkDefault={true}
          linkStyle={{ color: theme.colors.text.link }}
        >
          <Text style={styles.cardSubtitle} type={TextType.Caption2}>
            {text}
          </Text>
        </Hyperlink>
      )}
    </TouchableOpacity>
  );
};

const RichContent = ({ item, isFirst }) => {
  const theme = useTheme();
  const { type } = item;
  if (type === "image") {
    const { rawUrl } = item;
    if (rawUrl) {
      return (
        <Image
          source={{ uri: rawUrl }}
          style={[styles.container, { height: 150 }]}
        />
      );
    } else {
      return (
        <View style={[styles.container, { alignItems: "center" }]}>
          <RiskLevel4FullySafe color={theme.colors.icon.default} />
        </View>
      );
    }
  } else if (type === "info") {
    const { title, subtitle } = item;
    const hasTitle = !!title;
    const hasSubtitle = !!subtitle;
    return (
      <View>
        {hasTitle && (
          <Text
            style={isFirst ? null : styles.cardTitle}
            type={TextType.Caption1}
          >
            {title}
          </Text>
        )}
        {hasSubtitle && (
          <Text
            style={isFirst ? null : styles.cardSubtitle}
            type={TextType.Caption2}
          >
            {subtitle}
          </Text>
        )}
      </View>
    );
  } else if (type === "accordion") {
    return <Accordion item={item} />;
  } else if (type === "chips") {
    // VS: Ignoring chips - handling them as bottom suggestions.
    return <></>;
  } else if (type === "button") {
    // VS: Ignoring chips - handling them as bottom suggestions.
    return <></>;
  }
  // VS: Unsupported widget
  return <></>;
};

const ChatMessageContent = ({ content, onClick }) => {
  if (content.payload) {
    const {
      payload: { richContent },
    } = content;
    // VS: Check if there can be multiple records here
    const richItemArray = richContent[0];
    return (
      <View style={styles.chatRichCard}>
        {richItemArray.map((x, index) => (
          <RichContent item={x} key={index} isFirst={index === 0} />
        ))}
      </View>
    );
  } else if (content.text) {
    const message = content?.text?.text;
    return (
      <Text style={styles.chatTextContent} type={TextType.Caption1}>
        {message}
      </Text>
    );
  } else {
    return <></>;
  }
};

export const ChatMessage = ({ isMe, theme, content, onClick }) => {
  return (
    <View style={isMe ? styles.chatMessageMe : styles.chatMessageBot}>
      {isMe ? (
        <ChatBubbleMe theme={theme}>
          <ChatMessageContent content={content} onClick={onClick} />
        </ChatBubbleMe>
      ) : (
        <ChatBubbleBot theme={theme}>
          <ChatMessageContent content={content} onClick={onClick} />
        </ChatBubbleBot>
      )}
    </View>
  );
};

export const RenderMessage = ({ item, index, onClick, theme, isLast }) => {
  const { from, content } = item;
  return !content.event ? (
    <View
      style={[
        index === 0 ? styles.renderMessageMargin : null,
        { marginBottom: isLast ? 15 : 0 },
      ]}
    >
      <ChatMessage
        content={content}
        isMe={from === "me"}
        theme={theme}
        onClick={onClick}
      />
    </View>
  ) : (
    <></>
  );
};
